import moment from 'moment';

require('./speech-recognition-stats.scss');


const PULL_MIN_DELAY = 1000;
const PULL_MAX_DELAY = 10000;


class SpeechRecognitionStatsController {
  constructor($scope, $timeout, $http, $cookies) {
    this.$timeout = $timeout;
    this.$http = $http;
    this.$cookies = $cookies;
    this.reset_request = false;
  }

  $onInit() {
    this.pull_delay = 300;
    this.schedulePull();
  }

  $onDestroy() {
    this.destroyed = true;
    if (angular.isDefined(this.pull_promise)) {
      this.$timeout.cancel(this.pull_promise);
      delete this.pull_promise;
    }
  }

  reset() {
    this.reset_request = true;
  }

  get canReset() {
    return !!this.filter.id && !this.reset_request;
  }

  schedulePull(error) {
    if (error) { this.pull_delay *= 1.5; }

    if (PULL_MAX_DELAY < this.pull_delay) { this.pull_delay = PULL_MAX_DELAY; } else
    if (this.pull_delay < PULL_MIN_DELAY) { this.pull_delay = PULL_MIN_DELAY; }

    if (angular.isDefined(this.pull_promise)) {
      this.$timeout.cancel(this.pull_promise);
    }
    if (!this.destroyed) {
      this.pull_promise = this.$timeout(this.pullResults.bind(this), this.pull_delay);
    }
  }

  pullResults() {
    if (this.filter.id) {
      let url = '/speech_processing/stats?filter_id=' + this.filter.id;

      if (this.reset_request) {
        this.reset_request = false;
        url += '&reset'
      }

      this.$http.get(url,
          {headers: {
            'Accept': 'application/json;charset=utf-8',
            'X-CSRFToken': this.$cookies.get('csrftoken'),
          }})
      .then((response) => {
        if (response.data && angular.isObject(response.data.stats)) {
          this.updateStats(response.data.stats);
          this.pull_delay = PULL_MIN_DELAY;
          this.schedulePull();
        } else {
          console.error('Unknown response:', response.data);
          this.schedulePull(true);
        }
      })
      .catch((error) => {
        this.schedulePull(true);

        let message = angular.isString(error.data)
          ? error.data
          : angular.isObject(error.data) && angular.isString(error.data.message)
          ? error.data.message
          : error;

        console.error(message);
      });
    }
  }

  updateStats(stats) {
    this.stats = angular.copy(stats);
    if (angular.isDefined(this.stats.tinkoff_connections)) {
        this.stats.tinkoff = true;
    }
  }
}


export const SpeechRecognitionStatsComponent = {
  restrict    : 'E',
  template    : require('./speech-recognition-stats.html'),
  controller  : SpeechRecognitionStatsController,
  bindings    : {filter: '<'},
}



// WEBPACK FOOTER //
// ./src/speech/speech-recognition-stats.js